<template>
  <div class="layout-page-content-scroll" v-loading="isLoading">
    <vue-custom-scrollbar class="layout-page-content-scroll__scroll" :ref="'scroll'">
      <div class="layout-page-content-scroll__scroll-content">
        <slot></slot>
      </div>
    </vue-custom-scrollbar>
    <div class="layout-page-content-scroll__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import { APP_EVENTS } from '@/utils/events'

export default {
  name: 'LayoutContentScrollForm',
  props: {
    isLoading: { type: Boolean, default: false }
  },
  mounted () {
    this.$bus.$on(APP_EVENTS.SCROLL_LAYOUT_EDITOR, this.scrollTop)
  },
  beforeDestroy () {
    this.$bus.$off(APP_EVENTS.SCROLL_LAYOUT_EDITOR, this.scrollTop)
  },
  methods: {
    scrollTop () {
      requestAnimationFrame(() => {
        const scrollContent = this.$refs['scroll']
        scrollContent.$el.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="stylus">
  .layout-page-content-scroll{
    display grid
    grid-template-rows 1fr auto
    grid-template-columns 100%
    height 100%
  }
  .layout-page-content-scroll__scroll{
    height 100%
  }
  .layout-page-content-scroll__scroll-content{
    position absolute
    top 0
    right 0
    bottom 0
    left 0
    width calc(100% - 15px)
  }
  @media only screen and (max-width: 576px) {
    .layout-page-content-scroll__scroll-content {
      position static
      width 100%
    }
  }
</style>
